// extracted by mini-css-extract-plugin
export var modalCardWrapperStyle = "modal_wrapper-module--modalCardWrapperStyle--kgCq6";
export var modalCloseButtonWrapperStyle = "modal_wrapper-module--modalCloseButtonWrapperStyle--mMf98";
export var modalHeaderWrapperStyle = "modal_wrapper-module--modalHeaderWrapperStyle--oqXVo";
export var modalWrapperStyle = "modal_wrapper-module--modalWrapperStyle--OV3CB";